import { render, staticRenderFns } from "./SupportPushPopup.vue?vue&type=template&id=14769d74&scoped=true"
import script from "./SupportPushPopup.vue?vue&type=script&lang=js"
export * from "./SupportPushPopup.vue?vue&type=script&lang=js"
import style0 from "./SupportPushPopup.vue?vue&type=style&index=0&id=14769d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14769d74",
  null
  
)

export default component.exports